<div class="question-card">
	<div class="position-relative">
		<div class="attendee-question-text-wrapper">
			<div class="attendee-question-status">
				@if (questionContext === QuestionContextType.myQuestions) {
					@if (question.isOpen) {
						<span [title]="'Event_QA_OpenQuestion' | translate" [attr.aria-label]="'Event_QA_OpenQuestion' | translate" class="vb-icon vb-icon-question-mark"></span>
					} @else if (question.isAnsweredOrReplied) {
						@if (question.isPublic) {
							<span class="vb-icon vb-icon-group-nofill" [title]="'Event_QA_Reply_To_Public' | translate" [attr.aria-label]="'Event_QA_Reply_To_Public' | translate"></span>
						} @else {
							@if (question.isAnswered) {
								<span class="glyphicons ok_2" [title]="'Event_QA_Answered' | translate" [attr.aria-label]="'Event_QA_Answered' | translate"></span>
							} @else if (question.isDirectReplied) {
								<span class="glyphicons ok_2" [title]="'Event_QA_RepliedDirectly' | translate" [attr.aria-label]="'Event_QA_RepliedDirectly'| translate"></span>
							}
						}
					}
				} @else {
					@if (question.isPublic && question.isAnsweredOrReplied) {
						<span class="vb-icon vb-icon-group-nofill" [title]="'Event_QA_Reply_To_Public' | translate" [attr.aria-label]="'Event_QA_Reply_To_Public' | translate"></span>
					}
				}
			</div>
			<div class="attendee-question-content">
				<p class="question-text" [innerHTML]="question.questionText | safeHtml"></p>
				@if (question.anonymous) {
					<div class="anonymous-label">{{ 'Event_QuestionPostedAnonymously' | translate }}</div>
				}
			</div>
		</div>
		@if (question.replyText && question.repliedBy) {
			<div class="question-reply">
				<div class="question-reply-header">
				<div class="question-reply-avatar">
					<vb-profile-picture [profileUrl]="question.repliedBy.profileImageUri">
					</vb-profile-picture>
				</div>
				<div class="question-reply-meta">
					<span class="question-reply-author">{{question.repliedBy.firstName}} {{question.repliedBy.lastName}}</span>
				</div>
				</div>
				<p class="question-reply-text" [innerHTML]="question.replyText | safeHtml"></p>
			</div>
		} @else if (question.isClosed && question.isAnswered) {
			<div class="question-reply">
				{{ 'Event_QA_AnsweredBySpeaker' | translate }}
			</div>
		}
	</div>
</div>

